import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _da20547e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _2589624e = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: '--active',
  linkExactActiveClass: '--exact-active',
  scrollBehavior,

  routes: [{
    path: "/en",
    component: _da20547e,
    name: "index___en"
  }, {
    path: "/",
    component: _da20547e,
    name: "index___de"
  }, {
    path: "/en/*",
    component: _2589624e,
    name: "all___en"
  }, {
    path: "/*",
    component: _2589624e,
    name: "all___de"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
